import { ActivationCodeRepository } from "../../../../data/repository/activationCode/ActivationCodeRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DeleteActivationCodeUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class DeleteActivationCodeUseCaseImpl
  implements DeleteActivationCodeUseCase
{
  private repo: ActivationCodeRepository;

  constructor(repo: ActivationCodeRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.deleteActivationCode(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
